import { Component } from '@angular/core';

interface ReferralRegistrationSummary {
  name?: string;
  contact_email?: string;
  contact_phone?: string;
  company_name?: string;
  address?: string;
  ach_account_number?: string;
  ach_account_type?: string;
  tax_id?: string;
  ach_routing_number?: string;
}

interface ReferralSummaryItem {
  label: string;
  value: string;
}

@Component({
  selector: 'app-referral-registration-thank-you',
  templateUrl: './referral-registration-thank-you.component.html',
  styleUrls: ['./referral-registration-thank-you.component.scss']
})
export class ReferralRegistrationThankYouComponent {

  private readonly referralSummary: ReferralRegistrationSummary =
    history.state?.referralSummary || {};

  readonly summaryItems: ReferralSummaryItem[] = [
    { label: 'Name', value: this.formatValue(this.referralSummary.name) },
    { label: 'Email', value: this.formatValue(this.referralSummary.contact_email) },
    { label: 'Phone', value: this.formatValue(this.referralSummary.contact_phone) },
    { label: 'Company Name', value: this.formatValue(this.referralSummary.company_name) },
    { label: 'Address', value: this.formatValue(this.referralSummary.address) },
    { label: 'ACH Account Number', value: this.maskValue(this.referralSummary.ach_account_number) },
    { label: 'ACH Account Type', value: this.formatAccountType(this.referralSummary.ach_account_type) },
    { label: 'Tax ID', value: this.maskValue(this.referralSummary.tax_id) },
    { label: 'ACH Routing Number', value: this.formatValue(this.referralSummary.ach_routing_number) }
  ];

  get hasSummary(): boolean {
    return Object.keys(this.referralSummary).length > 0;
  }

  private formatValue(value?: string | null): string {
    return value || '-';
  }

  private formatAccountType(value?: string): string {
    if (!value) {
      return '-';
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  private maskValue(value?: string): string {
    if (!value) {
      return '-';
    }

    const visibleDigits = value.slice(-4);

    return `Ending in ${visibleDigits}`;
  }

}
